import React, {useEffect, useState} from 'react';
import {AuthenticatedTemplate, UnauthenticatedTemplate, useAccount, useMsal} from "@azure/msal-react";
import {loginRequest} from "../../authConfig";
import {useDispatch, useSelector} from "react-redux";
import Spinner from "../Spinner";
import * as actions from "../../actions/EmployeeActions";
import {loadEmployees} from "../helper functions/LoadEmployee";

export function EmployeeOverview() {
    const {instance} = useMsal();
    const account = useAccount();

    const loginRedirect = () => {
        instance.loginRedirect(loginRequest).catch((error) => console.log(error));
    };

    const dispatch = useDispatch()
    let sort = useSelector(state => state.employeeSort);
    let search = useSelector(state => state.employeeSearch);
    let filter = useSelector(state => state.employeeFilter)

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        //function will run after the component has rendered
        const timer = setTimeout(() => {
            setLoading(false);
        }, 300);

        return () => clearTimeout(timer);
    }, []);

    return (
        <div>
            {loading ? (<Spinner/>) : (
                <div>
                    <UnauthenticatedTemplate>
                        <h5 className="no-access-message"> Sorry, you don't have access to this page! </h5>
                    </UnauthenticatedTemplate>

                    <AuthenticatedTemplate>
                        <div className="page-title-sh26">
                            <h1>Employee Overview</h1>
                            <p>A list of all employees</p>
                        </div>
                        <hr/>

                        <a className="btn btn-secondary list-section-btn float-right"
                           href="/management/employees/add-employee"><span> Add Employee </span> </a>

                        <div className="search">
                            <input id="search-input" type="text" className="search-box"
                                   placeholder="Which job are you looking for?"/>
                            <button className="search-btn btn-secondary btn"
                                    onClick={search => dispatch(actions.search(document.getElementById("search-input").value, "ALL"))}> 🔍
                            </button>
                        </div>

                        <div className="page-break"></div>
                        <br/>

                        <div className="dropdown employee-dropdown">
                            <div className="dropdown-btn btn-secondary"> Sort by:</div>
                            <div className="dropdown-content">
                                <a onClick={sort => {
                                    dispatch(actions.SortNew("ALL"))
                                }}>Newest First </a>
                                <a onClick={sort => dispatch(actions.SortOld("ALL"))}>Oldest First</a>
                                <a onClick={sort => dispatch(actions.SortAtoZ("ALL"))}> A-Z </a>
                            </div>
                        </div>


                        <div className="dropdown mx-2 employee-dropdown">
                            <div className="dropdown-btn btn-secondary "> Filter by:</div>
                            <div className="dropdown-content">
                                <a onClick={filter => dispatch(actions.filter("CURRENT"))}> Current employees</a>
                                <a onClick={filter => dispatch(actions.filter("EX"))}> Ex-employees </a>
                            </div>
                        </div>

                        <div className="page-break"></div>
                        <br/>

                        {loadEmployees(sort, search, filter)}

                        <div className="page-break"></div>
                    </AuthenticatedTemplate>
                </div>
            )}
        </div>
    );
}
